import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { LocationEmptyState } from 'components/location-empty-state';
import LoyaltyInRestaurantRedemption from 'pages/loyalty/loyalty-in-restaurant-redemption/loyalty-in-restaurant-redemption';
import { t } from 'state/intl/translations';

export default function MyCodeScreen() {
  const { noStoreSelected } = useStoreRequired();

  if (noStoreSelected) {
    return <LocationEmptyState title={t('emptyMyCodeHeading')} message={t('emptyMenuMessage')} />;
  }

  return <LoyaltyInRestaurantRedemption />;
}
